import styled from "styled-components";

export const CheckUI = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
  backface-visibility: hidden;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  min-height: 17px;
  font-size: 1rem;
  line-height: 17px;
  min-width: 17px;
`;
